import ArrowLeft from "../../../assets/icons/arrow-left.svg";
import styled from "styled-components";
import { colors } from "../../../theme/color";
import { useNavigate } from "react-router-dom";

export const DashboardGoBackButton = () => {
  const navigate = useNavigate();
  return (
    <GoBackContainer onClick={() => navigate(-1)}>
      <img src="/assets/svg/goBack.svg" alt="Back Arrow" />
      <span>Go back</span>
    </GoBackContainer>
  );
};
const GoBackContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  span {
    color: ${colors.DARK_GRAY};
    font-family: "GT Walsheim Pro";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.24px;
  }
`;
